
/** @format */

import React, { useState, useEffect } from 'react';
import { Grid, Typography, IconButton, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import jMoment from 'moment-jalaali';
import { PageContainer, Icons , PriceLabel } from 'components';
import { constBreadCrumbsTitle } from 'utility';
import createToast from 'components/Toast/Toast';
import copy from 'copy-to-clipboard';
import { useNavigate, useParams } from 'react-router-dom';
import DiscountDetailServices from './services/DiscountDetailServices';
import { useCurrencyUnit } from 'hooks';

const CreditVoucherDetail = () => {
  // -- STATE --//
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const voucherId = useParams(); // id web service (entity ID)
  const currencyText = useCurrencyUnit(false);

  // --HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    if (voucherId?.id) {
      getDiscountDetail(voucherId?.id);
    }
  }, [voucherId]);

  // -- API REQUESTS --//
  const getDiscountDetail = async (id) => {
    try {
      setLoading(true);

      const res = await DiscountDetailServices.getVourcher(id);
      setCode(res?.result[0] ?? null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const copyItem = async (v) => {
    try {
      await copy(v);
      createToast('موفق', 'کد بن کپی شد.', 'success');
    } catch (e) {
      console.log(e);
      createToast('خطا', 'خطا در کپی کردن کد بن.', 'danger');
    }
  };

  //   const hint = 'در این بخش می‌توانید لیست بن‌های تخفیف صادر‌ شده  را مشاهده کنید.';

  return (
    <PageContainer
      title="اطلاعات بن شارژ"
      // description={hint}
      onBackClick={() => navigate(-1)}
      breadcrumbs={constBreadCrumbsTitle.VOUCHER_CREDIT_VOUCHER_DETAIL}
      className={classes.root}
    >
      <Grid container direction="row" alignItems="center" item>
        {/* TODO: Add new Loading component */}
        {loading ? <CircularProgress size={50} /> : null}
        {code && !loading ? (
          <Grid item xs={12}>
            <Typography className={classes.title}>{code?.name}</Typography>
            <Grid container xs={12} md={9} className={classes.info}>
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>مبلغ بن</Typography>
                <Typography className={classes.detailValueFa}>
                 <PriceLabel amount={code?.creditAmount} currency={currencyText} /> 
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>کد بن</Typography>
                <Typography className={classes.detailValue}>
                  {code?.hash ? (
                    <>
                      {code?.hash}
                      <IconButton
                        className={classes.copyIcon}
                        onClick={() => copyItem(code.hash)}
                        size="large">
                        <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                      </IconButton>
                    </>
                  ) : (
                    '-'
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>تاریخ انقضا</Typography>
                <Typography className={classes.detailValue}>
                  {code?.expireDate
                    ? jMoment(code.expireDate)?.format('dddd, jD jMMMM jYYYY') ?? '-'
                    : '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>وضعیت</Typography>
                <Typography className={classes.detailValue}>
                  {code?.used ? 'استفاده شده' : 'استفاده نشده'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>حساب تفصیلی</Typography>
                <Typography className={classes.detailValue}>
                  {code?.guild ? code.guild.name : '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>توضیحات بن شارژ</Typography>
                <Typography className={classes.detailValue}>{code?.description ?? '-'}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </PageContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingInlineStart: theme.spacing(2.5),
    boxSizing: 'border-box',
    '& ul': {
      margin: 0,
      padding: 0,
    },
  },
  title: {
    fontSize: 16,
    color: '#1d4065',
    fontWeight: 'bold',
    marginBottom: 15,
    marginInlineStart: theme.spacing(2),
  },
  copyIcon: {
    height: 10,
    width: 10,
    fontSize: 15,
    marginInlineStart: theme.spacing(1),
  },
  list: {
    border: `1px solid #e5e6e7`,
    borderRadius: 5,
    margin: 0,
  },
  info: {
    backgroundColor: '#eef1f5',
    border: 'solid 1px rgba(109, 114, 120, 0.18)',
    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
    fontFamily: 'Vazir',
  },
  detailValueFa: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },
  titleBox: {
    background: '#eef1f5',
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    boxSizing: 'border-box',
    marginBottom: 0,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  titleArrow: {
    color: '#b9c3ca',
    fontSize: 20,
  },
}));

export default CreditVoucherDetail;
